import { useIsLoggedIn } from '@/hooks/react-query/user/use-user'
import { __cCreatorCampaignService } from '@/services/client/__c.creator-campaign.service'
import { useQuery } from '@tanstack/react-query'

// Trả về danh sách đăng ký thật của user (GET /foc-campaigns/me/registrations).
// Không map/giả lập thêm field nào không có trong response - nơi dùng dữ liệu
// hiển thị (banner, thời gian...) phải tự đối chiếu sang danh sách campaign.
export const useMyCampaignRegistrations = () => {
  const isLoggedIn = useIsLoggedIn()

  return useQuery({
    queryKey: ['my-campaign-registrations'],
    queryFn: () => __cCreatorCampaignService.getMyRegistrations(),
    enabled: isLoggedIn,
  })
}
